import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import OptionalDropDown from "../Scaffolding/OptionalDropDown";
import {getValueFromOptions} from "../../utils/maybeAddLabelToOptions";

const CheckpointDropdown = ({updateCheckpointPath, datasets, tableData, id, labelText = 'Checkpoint'}) => {
    const [checkpointCheckBox, updateCheckpointCheckBox] = useState(false)
    const [checkpoint, updateCheckpoint] = useState(undefined)
    const [checkpointOptions, setCheckpointOptions] = useState([])

    useEffect(() => {
        const datasetParam = datasets.map(dataset => `"p_dataset=${dataset}"`).join(',');
        const tableDataParam = tableData.map(dataset => `"p_data=${dataset}"`).join(',');
        const query = `query {
                                schemasForCheckpoints(
                                    dataset: [${datasetParam}]
                                    tableData: [${tableDataParam}]
                                    ){
                                    checkpointName,
                                    checkpointPath,
                                    checkpointSchema,
                                dataset
                              }
                            }`;

        Promise.all([makeApolloClientCall(query)])
            .then(([checkpointResults]) => {
                const options = checkpointResults.schemasForCheckpoints
                    .map((value) => ({label: value.checkpointName, value}));
                setCheckpointOptions(options);
            });
    }, [datasets])


    return <>
        <OptionalDropDown dropDownValues={checkpointOptions}
                          selectedDropDownValue={getValueFromOptions(checkpoint, checkpointOptions)}
                          onDropDownChange={(value) => {
                              updateCheckpoint(value?.checkpointName);
                              value === undefined ? updateCheckpointPath({}) : updateCheckpointPath(value);
                          }}
                          checkBoxIsChecked={checkpointCheckBox}
                          onCheckBoxChange={() => {
                              updateCheckpointCheckBox(!checkpointCheckBox);
                              if (checkpointCheckBox) {
                                  updateCheckpointPath({})
                              }
                          }}
                          checkboxText={'Use an optional set of checkpoint data'}
                          labelText={labelText}
                          optionalClassName={`large-optional-dropdown ${id}`}
                          placeholder={"Select Checkpoint..."}/>
    </>;
};

CheckpointDropdown.propTypes = {
    id: PropTypes.string,
    updateCheckpointPath: PropTypes.func.isRequired,
    datasets: PropTypes.array.isRequired,
    tableData: PropTypes.array.isRequired,
    labelText: PropTypes.string
};

export default CheckpointDropdown;